import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCreditCard,
  faDotCircle,
  faTrash,
  faPlusCircle,
  faEdit,
  faSave,
  faEye,
  faClock,
  faCircleNotch,
  faCar,
  faChevronRight,
  faChevronLeft,
  faFileDownload,
  faUnlink,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faCreditCard,
  faDotCircle,
  faTrash,
  faPlusCircle,
  faEdit,
  faSave,
  faEye,
  faClock,
  faCircleNotch,
  faCar,
  faChevronRight,
  faChevronLeft,
  faFileDownload,
  faUnlink
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
